import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/lab-tests/history',
    redirectTo: '/labtests/history/TSH',
  },
];

export default redirects;
